import {
  FinderResultDto,
  HousingSiteDto,
  HousingSiteDetail,
  FormResponseDto,
  FormType,
} from "~/api";

export type FormResponseDtoPlus = FormResponseDto & {
  name: string;
  type: FormType;
};

export type ResultPlus = FinderResultDto & {
  site?: HousingSiteDto;
  remaining?: number;
  resultsIncluded: boolean;
  details: HousingSiteDetail[];
  hmbName: string;
};

export type RuleForm = {
  couple: boolean | undefined;
  age: number | undefined;
  income: number | undefined;
  otherAge: number | undefined;
  otherIncome: number | undefined;
};

export type HousingFilters = {
  sortingChosen: string;
  roomTypeChecklist: string[];
  quadrantCheckList: string[];
  locationCheckList: string[];
  housingOrgChecklist: string[];
  favoriteChecklist: boolean;
  buildingTypeChecklist: string[];
  buildingAttributeChecklist: string[];
  accessibleOnly: boolean;
};

export type LocationInfo = {
  location: string;
  disabled: boolean;
  quadrant: string;
  minAge: number;
  display: string;
};

export type QuadrantInfo = {
  quadrant: string;
  disabled: boolean;
};

export enum ApplicationWizardStep {
  SelectLocations = 0,
  ApplicationForm = 1,
  ReviewAndSubmit = 2,
}
